<template>
    <div class='shop-container'>
        <ph-header>
            <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
        </ph-header>
        <section class='certificate-upload-process mb24'>
            <!-- <div class="upload-process-item">
                <div class="icon"></div>
                <div class="text">网银转账</div>
            </div>
            <div class="upload-process-item">
                <div class="icon"></div>
                <div class="text">转账成功截图</div>
            </div>
            <div class="upload-process-item">
                <div class="icon"></div>
                <div class="text">上传凭证</div>
            </div> -->
            <img src="@/assets/img/certificate-upload.png" alt="" srcset="">
        </section>
        <section class="fill-information mb24">
            <div class="title ponhu-line fw"><span>网银转账</span></div>
            <div class="fill-information-content">
                <div class="fill-information-item ponhu-line">
                    <van-field
                        v-model="payee"
                        label="收款方"
                        disabled
                        placeholder="请输入收款方"
                    >
                    <van-button  slot="button" round size="mini" id='payee' type="ph-copy" @click="clipCopy('#payee',payee)">复制</van-button>
                    </van-field>
                </div>
                <div class="fill-information-item ponhu-line">
                    <van-field
                        v-model="account"
                        label="收款账户"
                        disabled
                        placeholder="请输入收款账户"
                    >
                    <van-button  slot="button" round size="mini" id='account' type="ph-copy" @click="clipCopy('#account',account)">复制</van-button>
                    </van-field>
                </div>
                <div class="fill-information-item ponhu-line">
                    <van-field
                        v-model="bank"
                        label="开户行"
                        disabled
                        placeholder="请输入开户行"
                    />
                </div>
                <div class="fill-information-item ponhu-line">
                    <van-field
                        v-model="amount"
                        label="转账金额"
                        disabled
                        placeholder="转账金额"
                    />
                </div>
            </div>
        </section>
        <section class="upload-certificate mb24">
            <div class="title ponhu-line fw"><span>上传凭证</span><span class="c999 fz24">转账成功后截图/拍照上传</span></div>
             <div class="upload-certificate-content">
                <van-uploader
                    :after-read="afterRead"
                    v-model="certFile"
                    :max-count="1"
                >
                <!-- TODO:自定义上传区域 -->
                    <div class="uploader-area">
                        <van-icon name="add-o" size="20"/>
                        <div class="upload-text fz18">添加</div>
                    </div>
                </van-uploader>
             </div>
        </section>
        <div class="submit-certificate">
            <van-button type="ponhu" size="large" @click="submit">提交</van-button>
        </div>
    </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import ClipboardJS from 'clipboard'
import { upload } from '@/utils/upload'
import { uploadBankCertificate, getOrderDetail } from '@/api/order'
import axios from 'axios'

export default {
  components: {
    PhHeader
  },
  data () {
    return {
      certFile: [],
      oid: '',
      payee: '',
      account: '',
      bank: '',
      amount: '',
      uploadURL: ''
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  watch: {
  },
  mounted () {
    this.oid = this.$route.params.oid
    getOrderDetail({ userToken: this.token, soNumber: this.oid }).then(res => {
      this.amount = res.orderAmount;
    }).catch(err => {
      this.$toast(err)
    })
    this.getBank();
  },
  methods: {
    clipCopy (item, value) {
      let that = this
      var clipboard = new ClipboardJS(item, {
        text: function (trigger) {
          return value
        }
      })
      clipboard.on('success', function (e) {
        that.$toast('已经复制到粘贴板！')
        e.clearSelection()
      })

      clipboard.on('error', function (e) {
        that.$toast('该设备不支持自动复制')
      })
      this.custService = false
    },
    submit () {
      // documentType 1付款 转账 2是充值 转账
      // console.log({ userToken: this.token, documentType: 1, orderNumber: this.oid, documentImg: this.uploadURL })
      if(this.uploadURL == "") {
        this.$toast("请上传凭证图片")
        return;
      }
      uploadBankCertificate({ userToken: this.token, documentType: 1, orderNumber: this.oid, documentImg: this.uploadURL }).then(res => {
        this.$toast(res)
        this.$router.replace({ name: 'paySuccess' })
      }).catch(error => {
        this.$toast(error)
        this.$router.replace({ name: 'payFail' })
      })
    },
    getBank() {
      axios.post("https://apiv2-app.ponhu.cn/index/getBankNumber").then(res => {
        if(res.data.code == 200) {
          var data = res.data.list;
          this.payee = data.payee;
          this.account = data.cardnum;
          this.bank = data.branch_bank;
        }
      })
    },
    afterRead (file) {
      this.$toast.loading({
        mask: true,
        message: '上传中...',
        duration: 0
      })
      // 此时可以自行将文件上传至服务器
      console.log(file.file)
      var formData = new FormData()
      formData.append('useChannel', 'OnlineBanking')
      formData.append('file', file.file)

      upload('miniapps/common/uploadPicture', formData).then(res => {
        this.uploadURL = res
        this.$toast.clear()
        this.$toast('上传成功')
      }).catch(error => {
        this.$toast.clear()
        this.$toast(error)
      })
    }
  }
}
</script>

<style lang="less" scoped>

.fill-information{
    background: #fff;
    position: relative;
    font-size: 28px;
    .title{
        padding: 24px;
        span{
            border-left: 6px solid #282828;
            padding-left:24px;
        }
    }
    &-content{
        padding: 24px;
        .van-cell{
            color: #999;
        }
    }
}
.upload-certificate{
    background: #fff;
    position: relative;
    font-size: 28px;
    margin-bottom: 200px;
    .title{
        padding: 24px;
        span{
            padding-left:24px;
            margin-right: 10px;
            &:first-child{
                border-left: 6px solid #282828;
            }
        }
    }
    &-content{
        padding: 24px 24px 10px 24px;
    }
    .uploader-area{
        width:150px;
        height: 150px;
        background:#EEE;
        color: #9B9B9B;
        border-radius:4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .upload-text{
            margin-top: 5px;
        }
    }
}
.submit-certificate{
    position: fixed;
    width:100%;
    left:0;
    bottom: 0;
    right:0;
}
</style>
